import React, { Component } from 'react'
import {
  getFund,
  getProductListByCategory,
  getHistoricalData,
} from '../FundDetails/Data/FundDetailsDataSource.js'
import { getUrlParameter } from '../../global/data/url.js'
import { init } from '../../global/authentication/secure-link-manager.js'
import { setFundGroupProductTypeAndFundPath } from '../FundDetails/Data/FundTypes.js'
import { showAlertBanner } from '../AlertBanner/index.js'
import { STATUS_ERROR } from '../AlertBanner/Constants.js'
import {
  ERROR_MESSAGE_TITLE,
  FUND_DETAILS_ERROR_MESSAGE_TEXT,
} from '../../spa/components/investmentProducts/helpers/ErrorMessages.js'
import { isEtf } from '../FundDetails/Helpers/CheckProductType.js'
import FundHeaderMain from '../FundDetails/Modules/FundHeader/FundHeaderMain.jsx'
import FundHeaderMessage from '../FundDetails/Modules/FundHeader/FundHeaderMessage.jsx'
import HistoricalDataDetails from './HistoricalDataDetails.jsx'
import './index.css'
import FundViewer from '../FundDetails/Modules/MutualFundViewer/FundViewer.jsx'
import { setMeta } from '../FundDetails/Helpers/Meta.js'
import Loader from '../FundDetails/Modules/Shared/Loader.jsx'
import { triggerDigitalData } from '../FundDetails/Helpers/Analytics.js'

class HistoricalData extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fund: null,
      historicalData: null,
    }
  }

  _getDataList(historicalData) {
    const dtoList =
      historicalData &&
      historicalData.value &&
      historicalData.value.historicalMonthData

    if (dtoList && dtoList.length > 0) {
      return dtoList
    }

    return null
  }

  async _updateFundData(fund, productList, cusip) {
    if (cusip) {
      let historicalData = await getHistoricalData(cusip)

      triggerDigitalData(cusip, fund, 'Historical Data')

      this.setState({
        fund,
        productList,
        historicalData,
      })
    } else {
      this.setState({
        fund,
        productList,
      })
    }
  }

  async componentDidMount() {
    const cusip = getUrlParameter('cusip')

    let _fund = await getFund(cusip)

    if (_fund && !_fund.error) {
      setFundGroupProductTypeAndFundPath(_fund)

      const _productList = await getProductListByCategory(_fund.productType)

      if (_productList && !_productList.error) {
        this._updateFundData(_fund, _productList, cusip)

        setMeta(_fund, 'Historical Data')
      }
    } else {
      showAlertBanner({
        status: STATUS_ERROR,
        title: ERROR_MESSAGE_TITLE,
        text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
      })
    }
  }

  componentDidUpdate() {
    init()
  }

  render() {
    const { fund, productList } = this.state
    const dtoList = this._getDataList(this.state.historicalData)

    return fund && dtoList ? (
      <div className="historical-data-details" id="historical-data-details">
        <FundViewer fund={fund} productList={productList} />

        <FundHeaderMain
          fund={fund}
          isEtf={isEtf(fund.miscellaneousDetails)}
          productList={productList}
        />
        <FundHeaderMessage fund={fund} />

        <HistoricalDataDetails
          data={dtoList}
          fundGroup={fund.miscellaneousDetails.fundGroup}
        />
      </div>
    ) : (
      <Loader />
    )
  }
}

export default HistoricalData
